
export const getArrayBufferFromFile = (file: File): Promise<string | ArrayBuffer> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.addEventListener("load", () => { resolve(reader.result) });
        reader.addEventListener("error", err => reject(err));
    });
}

export default getArrayBufferFromFile;